import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProcessStepProps {
  title: string;
  description: string;
  status: "pending" | "loading" | "completed" | "failed";
  children?: React.ReactNode;
}

export const ProcessStep = ({ title, description, status, children }: ProcessStepProps) => {
  return (
    <div className="space-y-3 animate-fade-in">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-1">
          {status === "loading" && (
            <Loader2 className="h-5 w-5 text-primary animate-spin" />
          )}
          {status === "completed" && (
            <CheckCircle2 className="h-5 w-5 text-success animate-scale-in" />
          )}
          {status === "failed" && (
            <XCircle className="h-5 w-5 text-destructive animate-scale-in" />
          )}
          {status === "pending" && (
            <div className="h-5 w-5 rounded-full border-2 border-muted" />
          )}
        </div>

        <div className="flex-1 space-y-2">
          <div>
            <h3 className="font-bold text-foreground">{title}</h3>
            <p
              className={cn(
                "text-sm",
                status === "failed"
                  ? "text-destructive"
                  : "text-muted-foreground"
              )}
            >
              {description}
            </p>
          </div>

          {(status === "completed" || status === "failed") && children && (
            <div className="animate-fade-in">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
